import { Fragment } from 'react'
import { RawButton } from '@/components/Button'
import styles from './Breadcrumb.module.css'

export interface BreadcrumbItem {
  id: string
  title: string
  onPress?: () => void
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

/**
 * A trail of links to the current item's ancestors.
 */
export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className={styles.breadcrumb}>
      {items.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 && <span className={styles.separator}>{'>'}</span>}
          {index === items.length - 1 ? (
            <span className={styles.breadcrumbCurrent}>{item.title}</span>
          ) : (
            <RawButton className={styles.breadcrumbLink} onPress={item.onPress}>
              {item.title}
            </RawButton>
          )}
        </Fragment>
      ))}
    </nav>
  )
}
